export function formatObject2String(obj) {
    if (obj && typeof obj === 'object') {
        let arr = [];
        Object.keys(obj).forEach((key) => {
            if (obj[key]) {
                arr.push(`${key}: ${obj[key]}`);
            }
        });

        return arr.join(', ');
    }
    return '';
}
